module.exports = __webpack_public_path__ + "img/married.b3639f31.svg";